import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_YELLOW } from "../../../constants/colors";
import { useMaintenance } from "../../../hooks/useMaintenance";
import { Button } from "../../atoms/Button";

export const Maintenance: React.FC = () => {
  const { maintenanceInfo } = useMaintenance();

  if (!maintenanceInfo) {
    return null;
  }
  return (
    <StyledWrapper>
      <StyledContentContainer>
        <StyledMainTitle>{maintenanceInfo.title}</StyledMainTitle>
        {maintenanceInfo.period_label && (
          <StyledPeriodBox>
            <StyledPeriodLabel>
              {maintenanceInfo.period_label}
            </StyledPeriodLabel>
            <StyledPeriodContent>
              <StyledPeriodDateText>
                {`${maintenanceInfo.app_start_date}から`}
              </StyledPeriodDateText>
              <StyledPeriodDateText>
                {`${maintenanceInfo.app_end_date}まで`}
              </StyledPeriodDateText>
            </StyledPeriodContent>
          </StyledPeriodBox>
        )}
        <StyledMessage>{maintenanceInfo.message}</StyledMessage>
      </StyledContentContainer>
      <Button
        text="再度読み込み"
        onClick={() => window.location.reload()}
        btnStyle="primary"
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  width: 100%;
  min-width: 300px;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 400px);
  padding: 0 16px;
`;

const StyledMainTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  color: ${BASIC_DARK_GRAY};
  margin-bottom: 12px;
  line-height: 1.4;
  text-align: center;
`;

const StyledPeriodBox = styled.div`
  width: 100%;
  border-radius: 5px;
  border: 2px solid ${BASIC_YELLOW};
  padding: 20px;
  margin-bottom: 30px;
  background-color: white;
  text-align: center;
  box-sizing: border-box;
`;

const StyledPeriodLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${BASIC_DARK_GRAY};
  margin-bottom: 20px;
`;

const StyledPeriodContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const StyledPeriodDateText = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${BASIC_DARK_GRAY};
  line-height: 1.5;
  word-break: break-all;
`;

const StyledMessage = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${BASIC_DARK_GRAY};
  line-height: 1.6;
  word-break: break-all;
`;
